import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { styled } from '../stitches.config';
import { Button } from './Button';
export var MenuRoot = styled(DropdownMenu.Root, {});
export var MenuTrigger = styled(DropdownMenu.Trigger, {});
MenuTrigger.defaultProps = {
    as: Button,
};
export var MenuContent = styled(DropdownMenu.Content, {
    backgroundColor: '$white',
    color: '$black',
    padding: '$1',
    borderRadius: 4,
});
export var MenuLabel = styled(DropdownMenu.Label, {});
export var MenuItem = styled(DropdownMenu.Item, {});
export var MenuGroup = styled(DropdownMenu.Group, {});
export var MenuArrow = styled(DropdownMenu.Arrow, {
    fill: '$white',
});
//# sourceMappingURL=Menu.js.map